<template>
  <div>
        <v-container fluid grid-list-xl>
          <v-layout row wrap>
<folder-parent-enfant 
          v-for="(projects, index) in listOfLatest" 
          :key="index"
          :projects="projects" 
          :deletable="false"
        />

          </v-layout>
        </v-container>
  </div>
</template>

<script>
import folderParentEnfant from "@/components/folder-parent-enfant.vue";

export default {
  name: "latestProjects",
  components: {
    folderParentEnfant
  },
  data() {
    return {
      listOfLatest: [],
    };
  },
  beforeMount() {
    (async () => {
      let latest = this.$store.getters["project/getLatestProj"];
      this.listOfLatest = await this.organizeLatestProj(latest);
    })();
  }
};
</script>
<style scoped>
.container.fluid{
  background: #171717 !important;
}
.directory {
  position: relative;
  width: 20px;
}
</style>
